/** Nominative Lithuanian month names (date-fns lt locale uses genitive: „spalio”). */
const MONTH_NAMES_LT_NOMINATIVE = [
  'Sausis',
  'Vasaris',
  'Kovas',
  'Balandis',
  'Gegužė',
  'Birželis',
  'Liepa',
  'Rugpjūtis',
  'Rugsėjis',
  'Spalis',
  'Lapkritis',
  'Gruodis'
] as const;

/** e.g. „Spalis 2026” instead of date-fns „spalio 2026”. */
export function formatMonthYearLt(date: Date): string {
  const month = MONTH_NAMES_LT_NOMINATIVE[date.getMonth()] || '';
  return `${month} ${date.getFullYear()}`;
}
